import Categories from "@/pages/Categories";

export default function Page() {
  return <Categories />;
}
